/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { GbcarApiConfiguration as __Configuration } from '../gbcar-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { AddressDto } from '../models/address-dto';
import { ConditionalRequiredDto } from '../models/conditional-required-dto';
@Injectable({
  providedIn: 'root',
})
class AddressService extends __BaseService {
  static readonly putApiAddressAddressValidatePath = '/api/Address/AddressValidate';
  static readonly getApiAddressGetConditionalRequiredPath = '/api/Address/GetConditionalRequired';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param body undefined
   * @return Success
   */
  putApiAddressAddressValidateResponse(body?: AddressDto): __Observable<__StrictHttpResponse<AddressDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/Address/AddressValidate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AddressDto>;
      })
    );
  }
  /**
   * @param body undefined
   * @return Success
   */
  putApiAddressAddressValidate(body?: AddressDto): __Observable<AddressDto> {
    return this.putApiAddressAddressValidateResponse(body).pipe(
      __map(_r => _r.body as AddressDto)
    );
  }

  /**
   * @param addressTypeId undefined
   * @return Success
   */
  getApiAddressGetConditionalRequiredResponse(addressTypeId?: number): __Observable<__StrictHttpResponse<Array<ConditionalRequiredDto>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (addressTypeId != null) __params = __params.set('addressTypeId', addressTypeId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Address/GetConditionalRequired`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ConditionalRequiredDto>>;
      })
    );
  }
  /**
   * @param addressTypeId undefined
   * @return Success
   */
  getApiAddressGetConditionalRequired(addressTypeId?: number): __Observable<Array<ConditionalRequiredDto>> {
    return this.getApiAddressGetConditionalRequiredResponse(addressTypeId).pipe(
      __map(_r => _r.body as Array<ConditionalRequiredDto>)
    );
  }
}

module AddressService {
}

export { AddressService }
